import { AnyAction } from 'redux';
import { GlobalActions } from '@ps20-frontend/shop-integration-redux';

export const unfallZaehlstueckeReducer = (sectionState = 0, action: AnyAction): number => {
  switch (action.type) {
    case GlobalActions.UNFALL_ZAEHLSTUECKE_CHANGED: {
      const actionPayload: number = action.payload;
      return actionPayload;
    }
    default:
      return sectionState;
  }
};
